import { Outlet } from 'react-router-dom';
import { Bounce, ToastContainer } from 'react-toastify';

import { Box } from '@mui/system';

import Footer from 'components/Footer';
import Navbar from 'components/Navbar';

import { MainContentContainer } from './MainLayout.styles';

const MainLayout = () => {
  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <Navbar shouldShowSuperiorButtons={true} />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Bounce}
      />
      <MainContentContainer>
        <Outlet />
      </MainContentContainer>
      <Footer />
    </Box>
  );
};

export default MainLayout;
